import React, {useContext, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import {CustomerContext} from "../CustomerContext";
import {useAsyncEffect} from "../../../hooks/UseAsyncEffect";

export default function CustomerAddresses() {
    const navigate = useNavigate();
    const { customerId, customerInformationService, setError } = useContext(CustomerContext);
    const [loading, setLoading] = useState(false as boolean);
    const [addresses, setAddresses] = useState<CustomerAddress[]>([]);

    useAsyncEffect(async () => {
        try{
            if(customerId != null) {
                setLoading(true);
                const customerAddresses = await customerInformationService.getAddresses(customerId);
                if (customerAddresses){
                    setAddresses(customerAddresses);
                }
                
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setError({source: 'Get Addresses', ...error});
        }
    }, [customerId]);

    return (
        <>
            <h2 className="ui header">
                Customer Addresses
            </h2>
            {loading && <div className="ui active centered inline loader"/>}

            {!loading && <table className="ui compact table">
                <thead>
                <tr>
                    <th>House or Flat</th>
                    <th>Street</th>
                    <th>Locality</th>
                    <th>Town or City</th>
                    <th>County</th>
                    <th>Postal Code</th>
                    <th>Country Code</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {addresses.map((a: CustomerAddress) =>
                    <tr key={a.address.addressId}>
                        <td>{a.address.houseName} {a.address.houseNumber} {a.address.flatNumber}</td>
                        <td>{a.address.street}</td>
                        <td>{a.address.locality}</td>
                        <td>{a.address.townOrCity}</td>
                        <td>{a.address.county}</td>
                        <td>{a.address.postalCode}</td>
                        <td>{a.address.countryCode}</td>
                        <td>
                            <button className="ui primary button" type="submit" onClick={() => navigate(`/customers/${customerId}/address/${a.addressId}/update`)}>Edit</button>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>}
            {!loading && addresses.length == 0 && <Link to={`/customers/${customerId}/address/create`} className="ui green button">Add Address</Link>}
        </>
    )
}